/*
 * Copyright (c) 2023. American Express Company
 */

// theirs
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';
import React from 'react';

// ours
import LiteralsService from 'src/services/literals/LiteralsService';
import { ConnectAccountBottomButtonsViewModel } from 'src/types/view-models/connect-account-bottom-buttons.view.model';

// styles
import bottomButtonsStyles from 'src/components/bottom-buttons/BottomButtons.module.scss';

export default function ConnectAccountBottomButtons({
    currentAccount,
    type,
    handleOpenConfirmation,
    handleDelete,
    handleBack
}: ConnectAccountBottomButtonsViewModel): JSX.Element {
    return (
        <div className={bottomButtonsStyles.bottomButtons} data-cy="bottomButtons">
            <ButtonPrimary type="submit">
                {currentAccount?.id
                    ? LiteralsService.getLiteral('addAccountDrawer.updateButton', [type])
                    : LiteralsService.getLiteral('addAccountDrawer.addButton', [type])}
            </ButtonPrimary>
            <ButtonSecondary
                onClick={() => {
                    if (currentAccount?.id) {
                        handleOpenConfirmation({
                            onAction: handleDelete,
                            action: 'delete',
                            object: 'manual'
                        });
                    } else {
                        handleBack();
                    }
                }}
            >
                {LiteralsService.getLiteral(currentAccount ? 'CommonText.delete' : 'CommonText.cancel')}{' '}
            </ButtonSecondary>
        </div>
    );
}
